import ApiService from "@/services/api.service";

const route = 'clients';

const clients = {
    get(_params) {
        return new Promise((resolve, reject) => {
            var params = [];

            if (_params.cpf_cnpj != null) {
                params.push("cpf_cnpj=" + _params.cpf_cnpj);
            }

            params = "?" + params.join("&");
            
            ApiService.get(route + params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default clients;